import styled from '@emotion/styled';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import { withConfig } from 'src/withConfig';

export const TermsWrapper = withConfig(theme => styled('div', { label: 'TermsWrapper' })`
    display: flex;
    justify-content: flex-end;
    margin: 0;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.regular};
    padding: 0 8px 0 8px;
    white-space: nowrap;
`);

export const SingleTermsWrapper = styled('span', { label: 'SingleTermsWrapper' })`
    margin-right: 5px;
`;

export const ChevronIconWrapper = styled(ChevronIcon, { label: 'ChevronIconWrapper' })`
    fill: currentcolor;
    flex: 0 0 12px;
    margin: 0 8px;
    width: 12px;
`;
